export default "__VITE_ASSET__BeDS7Qdo__"